import { Injectable } from '@angular/core';
import { IFormMasterBuilder } from '../form/form-master.interface';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Injectable()
export class ChatFormBuilder implements IFormMasterBuilder {
  FORM_KEYS = {
    MESSAGE: 'message',
  };

  constructor(private _formBuilder: FormBuilder) {}

  buildForm(messageMaxLength: number): FormGroup {
    return this._formBuilder.group(
      {
        [this.FORM_KEYS.MESSAGE]: [
          '',
          [Validators.required, Validators.maxLength(messageMaxLength)],
        ],
      },
      { updateOn: 'blur' }
    );
  }
}
